import { GVHttpClient } from '@gvdasa/gv-core';
import { AxiosInstance } from 'axios';
import { Environment } from '../../environment';

const Api = GVHttpClient(Environment) as AxiosInstance;

export { Api };
